import { render, staticRenderFns } from "./EmergencyModal.vue?vue&type=template&id=130b6464&scoped=true"
import script from "./EmergencyModal.vue?vue&type=script&lang=js"
export * from "./EmergencyModal.vue?vue&type=script&lang=js"
import style0 from "./EmergencyModal.vue?vue&type=style&index=0&id=130b6464&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130b6464",
  null
  
)

export default component.exports